import React, {useState} from "react";
import WhiteCard from "../../../../../../components/card/WhiteCard";
import {TxtTitles} from "../../../../../../helpers/breadCrumbs";
import {useTranslation} from "react-i18next";
import AttenDanceSelector from "./AttenDanceSelector";


const ParticipationEventItem = ({ event, handleChangeAttendance, onCommentChange }) => {
    const { t } = useTranslation();
    return (
        <div className="d-flex mt-3 gap-2 align-items-start">
            <div style={{ flexShrink: 0 }}>
                <WhiteCard classNames="p-3">
                    <TxtTitles>{t('project.availabilities.checkbox_title')}</TxtTitles>
                    <AttenDanceSelector
                        value={event.what_marked}
                        eventID={event.id}
                        onChange={handleChangeAttendance}
                    />
                </WhiteCard>
            </div>
            <div style={{ flexGrow: 1 }}>
                <WhiteCard classNames="p-3">
                    <div className="w-100 d-flex flex-row flex-wrap flex-md-nowrap align-items-center">
                        <div style={{ width: '20%' }}>
                            <TxtTitles>{t('events.date')}</TxtTitles>
                            {event.data}
                        </div>
                        <div style={{ width: '20%' }}>
                            <TxtTitles>{t('events.start_end')}</TxtTitles>
                            {event.time_od} - {event.time_do}
                        </div>
                        <div style={{ width: '15%' }}>
                            <TxtTitles>{t('events.type')}</TxtTitles>
                            {t('project.events.' + event.type)}
                        </div>
                        <div style={{ width: '20%' }}>
                            <TxtTitles>{t('events.composition')}</TxtTitles>
                            {event.composition.map((el, i) => (
                                <React.Fragment key={i}>
                                    <span className="me-2">{el}</span>
                                    {(i + 1) % 3 === 0 && <br />}
                                </React.Fragment>
                            ))}
                            {+event.musReduction > 0 ? `(-${event.musReduction} ${t("offer.pdf_document.events.person_reduction")})` : null}
                        </div>
                    </div>
                    <div className="mt-3 w-100">
                        <label htmlFor={`comment_${event.id}`} className="form-label">
                            <TxtTitles>{t('project.availabilities.avail_input_title')}</TxtTitles>
                        </label>
                        <input
                            id={`comment_${event.id}`}
                            value={event?.comment || ""}
                            onChange={ev => onCommentChange(event.id, ev.target.value)}
                            type="text"
                            className="form-control"
                            placeholder={t('project.availabilities.avail_input_description')}
                        />
                    </div>
                </WhiteCard>
            </div>
        </div>
    );
};

export default ParticipationEventItem